import React from "react";
export const ExchangeRates = () => {
    return (
        <div>
           <p>ExchangeRates - todo</p>
        </div>
    );
};